import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useSelectorActiveChain } from 'components/hooks';

import { ButtonCssProps, Colors, buttonBasicCss } from './Button';

import type { LinkProps } from 'react-router-dom';

// type StyledProps = {
//   type: Colors;
//   isInline?: boolean;
//   isDisabled?: boolean;
//   className?: string;
// };

type StyledProps = ButtonCssProps & {
  disabled: boolean;
};

type Props = {
  to: LinkProps['to'];
  children: ReactNode;
  disabled?: boolean;
  inline?: boolean;
  bordered?: boolean;
  widePadding?: boolean;
  color?: Colors;
  className?: string;
};

const StyledLink = styled(
  Link
  // ({
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   isInline,
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   isBordered,
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   isDisabled,
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   widePadding,
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   colorName,
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   activeChain,
  //   ...props
  // }) => <Link {...props} />
  // .... & ButtonCssProps & { isInline: boolean }>
)<StyledProps>`
  ${buttonBasicCss}
  display: ${props => (props.$isInline ? 'inline-flex' : 'flex')};
  text-decoration: none;
  justify-content: center;
  align-items: center;
`;

function ButtonRouterLink({
  to,
  children,
  inline = false,
  disabled = false,
  bordered = false,
  widePadding = false,
  color = 'active',
  className,
}: Props) {
  const { activeChain } = useSelectorActiveChain();
  return (
    <StyledLink
      to={disabled ? '#' : to}
      style={disabled ? { pointerEvents: 'none' } : undefined}
      $isInline={inline}
      // isDisabled={disabled}
      disabled={disabled}
      $isBordered={bordered}
      $widePadding={widePadding}
      $minimalPadding={false}
      $colorName={color}
      $activeChain={activeChain}
      $fontNotBold={false}
      className={className}
    >
      {children}
    </StyledLink>
  );
}

export default ButtonRouterLink;
